<template lang="pug">
    .re-cart-empty
        .re-cart-empty-icon
            img(src="/images/client/got-me-hookd/cart-empty-icon.svg" alt="")
        .re-box-form-title Your cart is empty
        re-button.re-button--secondary.re-button--sm(@click="goToHome") Go to home page

</template>

<script>
import ReCartEmpty from 'utils/vue/components/complex/cart/general/re-cart-empty/script.js'

export default {
    name: 'gmh-cart-empty',

    mixins: [
        ReCartEmpty,
    ],
}
</script>
